import { AgencyLink } from "../AgencyLink";
import { AllocationCodeXref } from "../AllocationCodeXref";
import { ChangeOptions } from "../ChangeOptions";
import { ChargeCodeXref } from "../ChargeCodeXref";
import { CommodityXref } from "../CommodityXref";
import { DeductCodeXref } from "../DeductCodeXref";
import { EdiApiUsers } from "../EdiApiUsers";
import { EdiNotify } from "../EdiNotify";
import { EdiPartnerQualifiers } from "../EdiPartnerQualifiers";
import { EdiReplyCodePartners } from "../EdiReplyCodePartners";
import { HandlingRequirementXref } from "../HandlingRequirementXref";
import { InboundFuncAck } from "../InboundFuncAck";
import { LoadTenderReplyProfile } from "../LoadTenderReplyProfile";
import { LocationCustomerXref } from "../LocationCustomerXref";
import { OrderTypeXref } from "../OrderTypeXref";
import { PackageTypeXref } from "../PackageTypeXref";
import { RevenueCodeXref } from "../RevenueCodeXref";
import { TenderProfileCompareOptions } from "../TenderProfileCompareOptions";
import { TrailerTypeXref } from "../TrailerTypeXref";
import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTenderProfile extends Layout {
    buttonAckTemplateSetup: Button;
    buttonCustomFilename: Button;
    buttonCustomer: Button;
    buttonCustomizeTransControNoi: Button;
    buttonFAMasterBatch: Button;
    buttonFilenameCustomize: Button;
    buttonMasterBatch: Button;
    buttonOpenClassic: Button;
    buttonRemoveCustomer: Button;
    buttonReplySetup: Button;
    buttonSetup: Button;
    buttonTransactionCustomize: Button;
    checkboxAutoCancel: Checkbox;
    checkboxAutoCreateOrder: Checkbox;
    checkboxAutoCreateReply: Checkbox;
    checkboxBlUpdatesOrder: Checkbox;
    checkboxFuncUseMBatch: Checkbox;
    checkboxIgnoreMapErrors: Checkbox;
    checkboxIntercompany: Checkbox;
    checkboxLockMiles: Checkbox;
    checkboxMasterBatch: Checkbox;
    checkboxOverrideWarning: Checkbox;
    checkboxPartnerCodeCar: Checkbox;
    checkboxPartnerCodeLoc: Checkbox;
    checkboxRequiresReply: Checkbox;
    checkboxSendFuncAck: Checkbox;
    dataheaderTenderProfile: DataHeader;
    labelAddCarrier: Label;
    labelCustomers: Label;
    labelDefaultValues: Label;
    labelDirectionOutbound: Label;
    labelFuncMasterBatch: Label;
    labelNextBatchNumber: Label;
    labelOptions: Label;
    labelRuleGroupDesc1: Label;
    labelRuleGroupDesc2: Label;
    labelRuleGroupHeader2: Label;
    labelRuleGroupHeader: Label;
    labelThistabistobeusedwithcopyorderYoumusthavethisprofilesetupintheoperatingTMSalsoChangeandorCancelswillbereplicatedintheoperatingTMS: Label;
    layoutAgencyLink: AgencyLink;
    layoutAllocationCodeXref: AllocationCodeXref;
    layoutChangeOptions: ChangeOptions;
    layoutChargeCode: ChargeCodeXref;
    layoutCommodity: CommodityXref;
    layoutCompareOptions: TenderProfileCompareOptions;
    layoutCrossReference: LocationCustomerXref;
    layoutDeductCodeXref: DeductCodeXref;
    layoutEdiApiUsers: EdiApiUsers;
    layoutEdiPartnerQualifiers: EdiPartnerQualifiers;
    layoutEdiReplyCodePartners: EdiReplyCodePartners;
    layoutHandlingRequirementXref: HandlingRequirementXref;
    layoutInboundFuncAck: InboundFuncAck;
    layoutNotifications: EdiNotify;
    layoutOrderTypeXref: OrderTypeXref;
    layoutPackagingTypeCode: PackageTypeXref;
    layoutReply: LoadTenderReplyProfile;
    layoutRevenueCode: RevenueCodeXref;
    layoutTrailerType: TrailerTypeXref;
    panelCrossReference: Panel;
    panelFuncBatch: Panel;
    panelGeneralInbound: Panel;
    panelGeneralLeft: Panel;
    panelGeneralOutLeft: Panel;
    panelGeneralOutRight: Panel;
    panelGeneralRight: Panel;
    panelHeader: Panel;
    panelInboundFuncAck: Panel;
    panelInboundGeneral: Panel;
    panelInboundReply: Panel;
    panelNotes: Panel;
    panelOutboundFuncAck: Panel;
    panelOutboundGeneral: Panel;
    panelReplyRight: Panel;
    sourceAgencyLink: DataSource;
    sourceChargeCodeEdi: DataSource;
    sourceDeductCodeEdi: DataSource;
    sourceEdiApiUser: DataSource;
    sourceEdiCarrier: DataSource;
    sourceEdiCommodity: DataSource;
    sourceEdiCopyToCompany: DataSource;
    sourceEdiCrossRef: DataSource;
    sourceEdiCrossRefAllocationCode: DataSource;
    sourceEdiCrossRefHandlingRequirement: DataSource;
    sourceEdiCrossRefOrderType: DataSource;
    sourceEdiCrossRefPackageTypeCode: DataSource;
    sourceEdiCrossRefRevenueCode: DataSource;
    sourceEdiCrossRefTrailerType: DataSource;
    sourceEdiCustomer: DataSource;
    sourceEdiNotify: DataSource;
    sourceEdiPartnerCodeDetail: DataSource;
    sourceEdiReplyCodeQualifiers: DataSource;
    sourceEdiReqdfldgroup: DataSource;
    sourceEdiRequiredFieldOutboundTender: DataSource;
    sourceEdiTemplateReply: DataSource;
    sourceEdiTemplateTender: DataSource;
    sourceEdilocation: DataSource;
    sourceEdiorderProfileDisplay: DataSource;
    switchAddCarrier: Switch;
    switchAutoAddCarrier: Switch;
    switchAutoCreateLocation: Switch;
    switchRecentChanges: Switch;
    tabAPI: Tab;
    tabAutoCreate: Tab;
    tabBillTo: Tab;
    tabCarrier: Tab;
    tabChangeOptions: Tab;
    tabCompare: Tab;
    tabCopyTo: Tab;
    tabCrossReferences: Tab;
    tabDataValidation: Tab;
    tabFunctionalAcknowledgement: Tab;
    tabGeneral: Tab;
    tabNotifications: Tab;
    tabPartnerNotes: Tab;
    tabPartnerQualifiers: Tab;
    tabReply: Tab;
    tabReplyCodes: Tab;
    tabResponsibility: Tab;
    tableCopyTo: Table;
    tableEdiCarrier: Table;
    tableEdiCustomer: Table;
    tableReqdFldGrp: Table;
    tableRequiredField: Table;
    tabsetTenderProfile: Tabset;
    textbox1FAThreshold: Textbox;
    textbox2ReplyAltPartnerId: Textbox;
    textboxAckXmitMethod: Textbox;
    textboxAltPartnerId: Textbox;
    textboxAutoCreateEdiLoc: Textbox;
    textboxAutoSendTender: Textbox;
    textboxCollectionMethod: Textbox;
    textboxCommId: Textbox;
    textboxCommodityId: Textbox;
    textboxCopyFromCompany: Textbox;
    textboxCurrencyTypeId: Textbox;
    textboxCustomer: Textbox;
    textboxDefMoveType: Textbox;
    textboxDirection: Textbox;
    textboxDupCutoffDays: Textbox;
    textboxEquipmentTypeId: Textbox;
    textboxFilename: Textbox;
    textboxFuncAckFilename: Textbox;
    textboxFuncAckSt02Frmt: Textbox;
    textboxFuncAckTid: Textbox;
    textboxFuncAltpartnerId: Textbox;
    textboxFuncCommId: Textbox;
    textboxFuncNextBatch: Textbox;
    textboxFuncPartnerId: Textbox;
    textboxFuncVersion: Textbox;
    textboxNextBatch: Textbox;
    textboxNotes: Textbox;
    textboxOldChangesReply: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderTypeId: Textbox;
    textboxPartnerId: Textbox;
    textboxPartnerName: Textbox;
    textboxPartnerStatus: Textbox;
    textboxPayeeExpenseGlid: Textbox;
    textboxPayeePayFreq: Textbox;
    textboxPayeePayMethod: Textbox;
    textboxPiecesInformation: Textbox;
    textboxProcessAs: Textbox;
    textboxProcessPriority: Textbox;
    textboxPromptXrefEdiLoc: Textbox;
    textboxRateInformation: Textbox;
    textboxRbdTimezoneId: Textbox;
    textboxReplyCommId: Textbox;
    textboxReplyNextBatch: Textbox;
    textboxReplyPartnerId: Textbox;
    textboxReplyTemplateId: Textbox;
    textboxReplyVersion: Textbox;
    textboxRespond: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxScac: Textbox;
    textboxSegAllocCode: Textbox;
    textboxSendToCompany: Textbox;
    textboxTemplateId: Textbox;
    textboxTransactionControl: Textbox;
    textboxTransactionSet: Textbox;
    textboxTransmitmethod: Textbox;
    textboxVersion: Textbox;
    textboxWeightInformation: Textbox;
}
